export default {
  title: {
    index: 'Automated Job Posting Management',
    editor: 'Edit Field Mapping Relationship',
    mappingManagement: '{channelName} - {fieldTypeName} - Mapping Relationship Management'
  },
  label: {
    channel: 'Channel',
    fieldType: 'Field',
    defaultValue: 'Default Value',
    selfField: 'AJINGA Field Value',
    otherField: '{channelName} Field Value',
    mappingType: 'Mapping Type',
    customMapping: 'Custom Mapping',
    jobCustomField: 'Job Custom Filed',
    salaryType: 'Salary Type',
    minSalary: 'Min Salary',
    maxSalary: 'Max Salary',
    salaryMonths: 'Salary Months',
    fixedValue: 'Fixed Value',
    customFields: 'Custom Fields'
  },
  placeholder: {
    minSalary: 'Min Salary',
    maxSalary: 'Max Salary',
    defaultValue: 'which will be used if the following configuration list is empty or does not match the corresponding item',
    inputFieldMappingValue: 'Please enter the corresponding value of "{fieldTypeName}" field on {channelName} page'
  },
  btn: {
    addMapItem: 'Click Here To Add A New Line'
  },
  message: {
    defaultIsRequired: 'Default value is required',
    mappingHasEmpty: 'There is an empty value in the configuration list. Please fill in or remove this line'
  }
}
